// hooks/useAtualizarDados.ts
import { useState } from "react";
import { excluirAnuncio } from "../../../services/excluirAnuncioService";
// --------------------- Import Services ---------------------

export const useExcluirAnuncio = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const excluir = async (id: number) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const dadosExcluidos = await excluirAnuncio(id);
      if (dadosExcluidos) {
        setSuccess(true);
      } else {
        setError(true);
      }
      return dadosExcluidos;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    excluir,
    isLoading,
    isSuccess,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
